(function (Drupal, once) {
  Drupal.behaviors.mobileViewToggle = {
    attach(context) {
      once('mobile-view-toggle', '.mobile-view-toggle', context).forEach((button) => {
        const container = button.previousElementSibling;
        const icon = button.querySelector('.mobile-view-toggle__icon');
        const text = button.querySelector('.mobile-view-toggle__text');

        if (
            !container ||
            !container.classList.contains('view-main-container') ||
            !icon ||
            !text
        ) {
          return;
        }

        const mapIcon = button.dataset.mapIcon;
        const listIcon = button.dataset.listIcon;

        button.addEventListener('click', () => {
          const showingMap = container.classList.toggle('show-map');

          if (showingMap) {
            text.textContent = 'LISTE ANZEIGEN';
            icon.src = listIcon;
          }
          else {
            text.textContent = 'KARTE ANSEHEN';
            icon.src = mapIcon;
          }
        });
      });
    }
  };
})(Drupal, once);